import {Component, Input} from '@angular/core';

import {HelpSiteFeesComponent} from "./components/help-site-fees/help-site-fees.component";
import {HelpAddFundsComponent} from "./components/help-add-funds/help-add-funds.component";
import {HelpRequestRefundComponent} from "./components/help-request-refund/help-request-refund.component";

@Component({
    selector: 'nz-charges-payments',
    imports: [
        HelpSiteFeesComponent,
        HelpAddFundsComponent,
        HelpRequestRefundComponent
    ],
    templateUrl: './charges-payments.component.html',
    styleUrl: './charges-payments.component.scss'
})
export class ChargesPaymentsComponent {
  @Input() subsectionId?: number;
}
